import jrEmailTypeaheadTemplate from '../../view/angular/common/email-typeahead.tpl.html';

angular
  .module('jrAutocompleteEmail', ['jrConfig', 'jrSubscription', 'jrUtil'])
  .filter('jrTypeaheadHighlight', [
    'emailFormatterService',
    function (emailFormatterService) {
      function escapeRegexp(queryToEscape) {
        return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
      }

      return function (matchItem, query) {
        const extractedQuery =
          !!query && emailFormatterService.hasDomainSeparator(query)
            ? emailFormatterService.getDomain(query)
            : undefined;

        return extractedQuery
          ? matchItem.replace(new RegExp(escapeRegexp(extractedQuery), 'gi'), '<strong>$&</strong>')
          : matchItem;
      };
    },
  ])
  .directive('jrEmailTypeahead', [
    'AutocompleteEmailConfig',
    'jrEmailConstants',
    'emailFormatterService',
    '$timeout',
    '$filter',
    function (AutocompleteEmailConfig, jrEmailConstants, emailFormatterService, $timeout, $filter) {
      return {
        restrict: 'AE',
        replace: true,
        scope: {
          placeholder: '@',
          disabled: '=',
          jobseeker: '=',
          focus: '=',
          email: '=',
          invalid: '=',
          cssclasses: '@',
        },
        template: jrEmailTypeaheadTemplate,
        link(scope, elem) {
          scope.typeaheadFirstItem = '';
          scope.providersList = AutocompleteEmailConfig.providersList;
          scope.providersLimit = AutocompleteEmailConfig.providersLimit;
          scope.emailDomainMinLength = AutocompleteEmailConfig.emailDomainMinLength;
          scope.typeaheadOnSelect = function (item, email) {
            const result = [];
            result.push(emailFormatterService.getUser(email));
            result.push(jrEmailConstants.domainSeparator);
            result.push(item.value);
            scope.jobseeker.email = result.join('');
            scope.typeaheadFirstItem = '';
          };

          scope.getProviderList = function (val) {
            const filteredProvidersList = $filter('limitTo')(
              $filter('emailDomainMatch')(
                AutocompleteEmailConfig.providersList,
                val,
                AutocompleteEmailConfig.emailDomainMinLength
              ),
              AutocompleteEmailConfig.providersLimit
            );

            if (filteredProvidersList.length > 0) {
              scope.typeaheadFirstItem = val.replace(/@.*/g, filteredProvidersList[0].label);
            } else {
              scope.typeaheadFirstItem = '';
            }

            return filteredProvidersList;
          };

          scope.$watch('focus', (value) => {
            if (value) {
              $timeout(() => {
                elem[0].querySelector('.jr-input').focus();
              });
            }
          });
        },
      };
    },
  ]);
